import pbjs from 'prebid.js';
import { getPermutiveSegments } from '@repo/utils';
import { BordeauxMachineContext, PreBid, PreBidEventTypes } from '@repo/shared-types';

import './prebidModules';
import { setTargeting } from './setTargeting';
import { buildUserSyncIds } from './userIds';
import {
  initialiseLiModule,
  paapiConfig,
  analyticsConfig,
  buildPrebidConfig,
  criteoConfig,
  bidderSettings,
} from './config';
import { onAuction, onBidWon } from './events';

export const prebid = pbjs as unknown as PreBid;

export const initialise = (
  context: Pick<
    BordeauxMachineContext,
    'liveIntentUserSyncEnabled' | 'config' | 'sommelierResponse' | 'thirdPartyApiConfig'
  >,
): void => {
  initialiseLiModule();
  const userSyncIds = buildUserSyncIds(context, !!pbjs.getUserIds().uid2);
  setTargeting();
  prebid.processQueue();

  prebid.que.push(() => {
    prebid.setConfig(paapiConfig);
    prebid.enableAnalytics(analyticsConfig);
    prebid.mergeConfig(buildPrebidConfig(context, userSyncIds));
    prebid.mergeConfig({
      ortb2: {
        user: {
          ext: {
            data: { permutive: getPermutiveSegments() },
          },
        },
      },
    });
    prebid.onEvent(PreBidEventTypes.ON_AUCTION, onAuction);
    prebid.onEvent<PreBidEventTypes.BID_WON>(PreBidEventTypes.BID_WON, onBidWon);
    prebid.setBidderConfig(criteoConfig);
    prebid.bidderSettings = { ...prebid.bidderSettings, ...bidderSettings };
  });
};
